import styled from "styled-components";
import { Icon } from "@iconify/react";

export const PageTitle = ({ title, onClick = () => { }, style = {} }) => {
  console.log("Rendering PageTitle with title:", title, onClick);
  return (
    <h2 style={{ color: "var(--main-font-color)", fontSize: "24px", fontWeight: "bold", marginBottom: "20px", ...style }} onClick={onClick}>
      {title}
    </h2>
  );
};

export const PageSubTitle = ({ title, style = {} }) => {
  return (
    <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px", ...style }}>
      {title}
    </h2>
  );
};

export const FormInput = styled.input.attrs({ className: 'nodrag nowheel' })`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  color: black;

  &:focus {
    outline: none;
    border-color: var(--button-bg);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  } 

`;


export const FormNumberInput = ({ value, min, max, step = 1, onChange, style = {} }) => {
  return (
    <div className="nodrag nowheel" style={{ position: "relative", display: "inline-block", width: "100%" }}>
      <input
        type="number"
        value={value}
        onChange={onChange}
        style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "16px", color: "black", ...style }}
      />
      <div style={{ display: "flex", flexDirection: "column", position: "absolute", right: "10px", top: "0", height: "100%", width: "20px" }}>
        <button
          style={{ height: "50%", display: "flex", alignItems: "center", justifyContent: "center", padding: "0", color: "black", outline: "none" }}
          onClick={() => {
            const factor = 1 / step;
            let newNumber = Math.ceil(factor * (Number(value) + step)) / factor;
            if (min !== undefined && newNumber < min) {
              newNumber = min;
            }
            if (max !== undefined && newNumber > max) {
              newNumber = max;
            }
            onChange({ target: { value: newNumber } })
          }} >
          ▲
        </button>
        <button
          style={{ height: "50%", display: "flex", alignItems: "center", justifyContent: "center", padding: "0", color: "black", outline: "none" }}
          onClick={() => {
            const factor = 1 / step;
            let newNumber = Math.floor(factor * (Number(value) - step)) / factor;
            if (min !== undefined && newNumber < min) {
              newNumber = min;
            }
            if (max !== undefined && newNumber > max) {
              newNumber = max;
            }
            if (min !== undefined && newNumber < min) {
              newNumber = min;
            }
            if (max !== undefined && newNumber > max) {
              newNumber = max;
            }

            onChange({ target: { value: newNumber } })
          }}>
          ▼
        </button>
      </div>
    </div >
  );
};

export const FormRange = styled.input.attrs({ type: 'range' })`
  width: 100%;
  height: 6px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;    
  -webkit-appearance: none;

  background: ${({ value, min = 0, max = 100, color = "var(--button-bg)" }) => {
    const percent = ((value - min) / (max - min)) * 100;
    return `linear-gradient(
      to right,
      ${color} 0%,
      ${color} ${percent}%,
      #ddd ${percent}%,
      #ddd 100%
    )`;
  }}; 

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--button-bg);
    cursor: pointer;
    border: none;
  }

  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #f87316;
    cursor: pointer;
    border: none;
  }

`;

export const FormToggle = styled.input.attrs({ type: 'checkbox' })`
  width: 42px;
  height: 22px;
  position: relative;
  appearance: none;
  background: #c6c6c6;
  outline: none;
  border-radius: 20px;
  transition: background 0.3s;
  cursor: pointer;

  &:checked, &:checked:hover, &:checked:focus {
    background: var(--button-bg);
    border: 1px solid #71717a;
  }

  &:focus {
    box-shadow: none;
  }

  &::before {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    top: 1px;
    left: 1px;
    background: #fff;
    transition: transform 0.3s;
    transform: translateX(0);
  }

  &:checked::before {
    transform: translateX(20px);
  }
`;

export const FormElement = ({ children, style = {} }) => {
  return (
    <div style={{ zIndex: 1, marginBottom: "16px", ...style }}>
      {children}
    </div>
  );
};

export const FormLabel = ({ label, style = {} }) => {
  return (
    <label style={{ display: "block", fontWeight: "600", marginBottom: "8px", ...style }}>
      {label}
    </label>
  );
};

export const FormSubLabel = ({ label, style = {} }) => {
  return (
    <label style={{ display: "block", fontWeight: "400", marginBottom: "4px", color: "var(--main-font-color)", fontSize: "14px", ...style }}>
      {label}
    </label>
  );
};

export const PageHeader = ({ children, style = {} }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderBottom: "1px solid #e0e0e0",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const CancelButton = styled.div`
  border-radius: 10px;
  padding: 5px 20px;
  height: 36px;
  width: fit-content;
  font-size: 16px;
  cursor: pointer;
  background-color: var(--cancel-button-bg);
  color: var(--cancel-button-color);

  &:hover {
    text-decoration: underline;
  }
`;

export const Button = styled.div`
  background-color: var(--button-bg);
  border-radius: 10px;
  color: var(--button-font-color);
  padding: 5px 12px;
  width: fit-content;
  height: 36px;
  font-size: 16px;
  cursor: pointer;
  text-wrap: nowrap;
  flex-grow: 0;
  flex-shrink: 1;
  font-weight: 600;
  line-height: 26px;

  &:hover {
    background-color: #d85300
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  // Property called enabled to control the button state
  ${(props) => props.disabled ? `background-color: #ccc; cursor: not-allowed; &:hover { background-color: #ccc }` : `background-color: var(--button-bg); cursor: pointer; &:hover { background-color: var(--button-hover-bg) }`}
`;

export const BackLink = styled.div`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const MetaInfo = ({ children, style = {} }) => {
  return (
    <span style={{ marginLeft: "10px", border: "1px solid #ccc", padding: "2px 8px", borderRadius: "10px", fontSize: "14px", color: "#666", ...style }}>
      {children}
    </span>
  );
};

export const ItalicSubTitle = styled.div`
    font-weight: 500;
    font-size: 16px;
    margin-top: 5px;
    color: var(--main-font-color);
    text-overflow: ellipsis;
    font-style: italic;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
`

export const FormSelector = ({ options = [], value = null, onChange = () => { } }) => {
  return (
    <select onChange={onChange} style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "16px" }} value={value}>
      {
        options.map((option) =>
          <option key={option.value} value={option.value}>{option.label}</option>
        )
      }
    </select>
  );
};

export const DragHandle = styled.div.attrs({ className: "node-drag-handle" })`
  cursor: move;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
`;

export const ResizeHandle = styled.div.attrs({ className: "node-resize-handle" })`
  cursor: nwse-resize;
  position: absolute;
  height: 12px;
  width: 12px;
  bottom: -6px;
  right: -6px;
  z-index: 1;
`;

export const ResizeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="#ff0071"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ position: 'absolute', right: 5, bottom: 5 }}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <polyline points="16 20 20 20 20 16" />
      <line x1="14" y1="14" x2="20" y2="20" />
      <polyline points="8 4 4 4 4 8" />
      <line x1="4" y1="4" x2="10" y2="10" />
    </svg>
  );
}

export const ExpandCollapseButton = ({ isExpanded, onClick }) => {
  return (
    <div onClick={onClick} style={{ position: "absolute", top: 5, right: 5, width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 2 }}>
      <Icon icon={isExpanded ? "mdi:arrow-down" : "mdi:caret-right"} width={20} height={20} color="var(--main-font-color)" />
    </div>
  );
};

export const CircleCheckbox = ({ checked, onChange, style = {} }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "20px", height: "20px", borderRadius: "50%", border: "1px solid #ccc", backgroundColor: checked ? "#c5e5a1" : "#fff", cursor: "pointer", ...style }} onClick={() => onChange(!checked)}>
      {checked ? <div style={{ color: "#346100" }}>
        <Icon icon="icomoon-free:checkmark" height={14} width={14} color="#346100" />
      </div>
        : null}
    </div>
  );
}
